export const logoCore = [
  "59 64",
  `
  <path d="M58.4286,20.0239c-1.2665,9.0118-7.0955,15.6379-14.3021,18.3833l11.1831,25.0566h-17.6372l-8.3547-23.6589h-10.0355l-3.3254,23.6589H0L8.9194,0H42.0894c10.4272,0,18.1046,7.9738,16.3402,20.0239h-.001Zm-21.7701,6.6959c2.8997,0,6.1563-2.4702,6.7854-6.9446,.6266-4.2759-1.8504-6.6458-4.7733-6.6458h-15.6394l-1.9104,13.5904h15.5376Z" style="fill:#fff;"/>
  `,
];
